type AdminBulkActionBarProps = {
  selectedCount: number;
  hiddenSelectedCount: number;
  saving?: boolean;
  disabled?: boolean;
  activeLabel: string;
  inactiveLabel: string;
  hiddenWarning?: string;
  onBulkStatus: (status: "active" | "inactive") => void;
  onClearVisibleSelection: () => void;
  onClearAllSelection: () => void;
};

export function AdminBulkActionBar({
  selectedCount,
  hiddenSelectedCount,
  saving = false,
  disabled = false,
  activeLabel,
  inactiveLabel,
  hiddenWarning = "選択中の一部が現在の絞り込み結果に含まれていません。",
  onBulkStatus,
  onClearVisibleSelection,
  onClearAllSelection
}: AdminBulkActionBarProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <section className="admin-bulk-action-bar" aria-label="一括操作">
      <div>
        <strong>{selectedCount}件を選択中</strong>
        {hiddenSelectedCount > 0 ? <p>{hiddenWarning}</p> : null}
      </div>
      <div className="admin-bulk-action-bar__actions">
        {hiddenSelectedCount > 0 ? (
          <button type="button" onClick={onClearVisibleSelection} disabled={saving}>
            現在の絞り込み結果の選択を解除
          </button>
        ) : null}
        <button type="button" onClick={onClearAllSelection} disabled={saving}>すべての選択を解除</button>
        <button type="button" onClick={() => onBulkStatus("active")} disabled={disabled || saving}>
          {activeLabel}
        </button>
        <button type="button" onClick={() => onBulkStatus("inactive")} disabled={disabled || saving}>
          {inactiveLabel}
        </button>
      </div>
    </section>
  );
}
